import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint, createFormField } from '@backstage/plugin-scaffolder-react/alpha';
import { DomainSelectField } from './fields/DomainSelectField/extensions';
import { MultiComponentSelectField } from './fields/MultiComponentSelectField/extensions';
import { MultiSectorSelectField } from './fields/MultiSectorSelectField/extensions';
import { MultiUserSelectField } from './fields/MultiUserSelectField/extensions';
import { UserSelectField } from './fields/UserSelectField/extensions';

export const scaffolderModuleFieldExt = createFrontendModule({
  pluginId: 'scaffolder',  
  extensions: [
    FormFieldBlueprint.make({
      name: 'domain-select-field',
      params: {        
        field: async () => createFormField({ name: 'DomainSelectField', component: DomainSelectField }),
      },
    }),
    FormFieldBlueprint.make({
      name: 'multi-component-select',
      params: {
        field: async () => createFormField({ name: 'MultiComponentSelectField', component: MultiComponentSelectField }),
      },
    }),
    FormFieldBlueprint.make({
      name: 'multi-sector-select-field',
      params: {
        field: async () => createFormField({ name: 'MultiSectorSelectField', component: MultiSectorSelectField }),
      },
    }),
    FormFieldBlueprint.make({
      name: 'multi-user-select-field',
      params: {
        field: async () => createFormField({ name: 'MultiUserSelectField', component: MultiUserSelectField }),
      },
    }),
    FormFieldBlueprint.make({
      name: 'user-select-field',
      params: {
        field: async () => createFormField({ name: 'UserSelectField', component: UserSelectField }),
      },
    }),
  ],
});
